// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.esThFENogISXbzTJ0h8j{padding-bottom:var(--spacing-xxxxs)}`, "",{"version":3,"sources":["webpack://./src/components/navigation/navigation-panel/sub-navigation-panel/ui-components/navigation-header/navigation-header.scss"],"names":[],"mappings":"AAAA,sBACI,mCAAA","sourcesContent":[".navigationHeader {\n    padding-bottom: var(--spacing-xxxxs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigationHeader": `esThFENogISXbzTJ0h8j`
};
export default ___CSS_LOADER_EXPORT___;
